import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from './services/axios';
import { createPinia } from 'pinia';
import 'sweetalert2/dist/sweetalert2.min.css'

const app = createApp(App);

// State Management
app.use(createPinia());

// Inject router
app.use(router);

// Provide Axios globally (for Composition API: inject('axios'))
app.provide('axios', axios);

// Optionally also make Axios available globally for Options API (optional)
app.config.globalProperties.$axios = axios;

app.mount('#app');